class selectFlexWidth {
  constructor(elem) {
    this.elem = elem;
    this.root = document.documentElement;
    this.helper = this.elem.parentNode.querySelector(".select-helper-element");
    this.events();
  }

  setWidth(root, element, helper) {
    if (element && helper) {
      helper.innerHTML = element.querySelector("option:checked").innerText;

      setTimeout(() => {
        root.style.setProperty(
          "--fixed-dynamic-size",
          `${helper.offsetWidth}px`
        );
      }, 25);
    }
  }

  events() {
    if (this.elem) {
      this.setWidth(this.root, this.elem, this.helper);

      this.elem.addEventListener("change", () => {
        this.setWidth(this.root, this.elem, this.helper);
      });

      setTimeout(() => {
        this.elem.classList.add("js-flex-select-processed");
      }, 26);
    }
  }
}

const selectElems = document.querySelectorAll(
  ".select--flex-width:not(.js-flex-select-processed)"
);

for (let selectElem of selectElems) {
  selectElem.selectFlexWidth = new selectFlexWidth(selectElem);
}
